import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import { selectCurrentUser } from 'src/app/store/auth/auth.selectors';

import { SiteHelperService } from '../../../core/helper/site.service';
import { Site, User } from '../../../shared/models';
import * as fromApp from '../../../store';
import { setActiveSite, updateSiteStep } from '../../../store/site/site.actions';
import { selectActiveSite, selectReadOnlyMapInfo } from '../../../store/site/site.selectors';

@Component({
  selector: 'fc-locate-property-page',
  templateUrl: './locate-property-page.component.html',
  styleUrls: ['./locate-property-page.component.scss'],
})
export class LocatePropertyPageComponent {
  destroyRef = inject(DestroyRef);
  siteId: number;
  activeSite: Site;
  readOnlyMap: boolean;
  isAdmin: boolean = false;
  currentUser: User = null;
  setStep: boolean = false;

  constructor(
    readonly router: Router,
    readonly route: ActivatedRoute,
    readonly siteHelperService: SiteHelperService,
    readonly store: Store<fromApp.AppState>
  ) {
    this.siteId = +this.route.snapshot.params.id;
    this.store
      .select(selectActiveSite)
      .pipe(
        filter(site => !isEmpty(site)),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(activeSite => {
        if (activeSite) {
          this.activeSite = activeSite;
        }
      });

    if (!this.activeSite) {
      this.store.dispatch(setActiveSite({ id: this.siteId }));
    }

    this.store
      .select(selectCurrentUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        this.currentUser = user;
        this.isAdmin = user.isAdmin;
      });

    this.store
      .select(selectReadOnlyMapInfo)
      .pipe(
        filter(() => this.currentUser !== null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(readOnlyInfo => {
        this.readOnlyMap = !this.siteHelperService.canSaveMap(readOnlyInfo);
        if (
          !this.readOnlyMap &&
          !readOnlyInfo.isAdmin &&
          readOnlyInfo.activeSite &&
          readOnlyInfo.activeSite.id !== null &&
          !this.setStep
        ) {
          this.store.dispatch(
            updateSiteStep({
              id: readOnlyInfo.activeSite.id,
              step: 'Parcel Selection',
            })
          );
          this.setStep = true;
        }
      });
  }

  onOutletLoaded(component: any) {
    component.siteId = this.siteId;
    component.activeSite = this.activeSite;
  }
}
